module.exports = __webpack_public_path__ + "img/profitable-img-3.a4129361.png";